import $ from 'jquery';
import Isotope from 'isotope-layout';
import imagesLoaded from 'imagesloaded';

imagesLoaded.makeJQueryPlugin($);

const parent = $('.catalog-content-template__catalogs');
const autoComplete = $('.catalogs-autocomplete');

$.ui.autocomplete.prototype._resizeMenu = function () {
    var ul = this.menu.element;
    ul.outerWidth(this.element.outerWidth());
};

if (autoComplete.length) {
    autoComplete.autocomplete({
        source: JSON.parse(autoComplete.attr('data-vals')),
        create: function () {
            $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
                return $('<li>')
                    .append(
                        `<a href="${item.url}" target="_blank" rel="noopener noreferrer">${item.label}</a>`
                    )
                    .appendTo(ul);
            };
        },
        open: function (event) {
            $(event.target).addClass('autocomplete-active');
        },
        close: function (event) {
            $(event.target).removeClass('autocomplete-active');
        },
        select: function (event) {
            $(event.target).val('');
            return false;
        },
    });
}

if (parent.length) {
    parent.each(function () {
        const currentParent = $(this);
        const currentFilter = currentParent.parent().find('.partner-filter');

        const iso = new Isotope(currentParent[0], {
            itemSelector: '.catalog-feed-template',
            percentPosition: true,
            masonry: {
                columnWidth: '.partners-content-template__partner-sizer',
            },
        });

        currentParent.imagesLoaded(function () {
            iso.layout();
        });

        currentFilter.on('click', function () {
            const currentFilter = $(this);
            const allFilters = currentFilter.parent().find('.partner-filter');
            const val = currentFilter.attr('data-id') * 1;

            if (currentFilter.attr('data-active') === 'true') {
                iso.arrange({ filter: '*' });
                currentFilter.attr('data-active', false);
                currentParent
                    .parent()
                    .find('.partner-filter--all')
                    .attr('data-active', true);
                return;
            }

            if (0 === val) {
                iso.arrange({ filter: '*' });
                allFilters.attr('data-active', false);
                currentFilter.attr('data-active', true);
                currentParent
                    .parent()
                    .find('.partner-filter--all')
                    .attr('data-active', true);
                return;
            }

            allFilters.attr('data-active', false);
            currentFilter.attr('data-active', true);

            iso.arrange({
                filter: function () {
                    const $this = $(this);
                    const wrapper = $this;

                    if (
                        $this.hasClass(
                            'partners-content-template__partner-sizer'
                        )
                    ) {
                        return false;
                    }

                    const attr = wrapper.attr('data-types');
                    const types = attr.includes(',') ? attr.split(',') : [attr];
                    const newTypes = types.map(Number);

                    return newTypes.includes(val);
                },
            });
        });
    });
}
